import { X, ScanLine, PenLine, Package } from 'lucide-react';

const SOURCE = {
  scan: { label: 'Scan', icon: ScanLine, cls: 'text-sky-400 bg-sky-500/10' },
  manual: { label: 'Manuel', icon: PenLine, cls: 'text-slate-300 bg-slate-700/60' },
  inventory: { label: 'Inventaire', icon: Package, cls: 'text-violet-300 bg-violet-500/10' },
};

export const PartSourceBadge = ({ source }) => {
  const s = SOURCE[source] || SOURCE.manual;
  const Icon = s.icon;
  return <span className={`inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded ${s.cls}`}><Icon size={10} />{s.label}</span>;
};

export const OrderPartsList = ({ parts, onChange, disabled, inputCls }) => {
  if (!parts?.length) return null;
  const update = (i, field, val) => onChange(parts.map((p, idx) => (idx === i ? { ...p, [field]: val } : p)));
  const remove = (i) => onChange(parts.filter((_, idx) => idx !== i));

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-3 space-y-2" data-testid="order-parts-list">
      <p className="text-xs text-slate-300 font-medium">Pièces du bon ({parts.length})</p>
      <p className="text-[10px] text-slate-500">Le prix client est calculé automatiquement sur la facture (marge de la catégorie ou de la charte).</p>
      {parts.map((p, i) => (
        <div key={p.id || i} className="bg-slate-900 rounded-lg p-2 space-y-1.5" data-testid={`order-part-${i}`}>
          <div className="flex items-center justify-between gap-2">
            <PartSourceBadge source={p.source} />
            <span className="text-[10px] text-slate-500 truncate flex-1">{p.inventory_item_id && p.location ? <span className="text-amber-300 font-mono">{p.location}</span> : p.supplier}</span>
            {!disabled && <button onClick={() => remove(i)} className="text-red-400 p-0.5" data-testid={`order-part-remove-${i}`}><X size={12} /></button>}
          </div>
          <div className="grid grid-cols-2 gap-1.5">
            <input type="text" value={p.name || ''} onChange={e => update(i, 'name', e.target.value)} placeholder="Nom" disabled={disabled || !!p.inventory_item_id} className={`${inputCls} text-xs py-1.5`} />
            <input type="text" value={p.part_number || ''} onChange={e => update(i, 'part_number', e.target.value)} placeholder="No pièce" disabled={disabled || !!p.inventory_item_id} className={`${inputCls} text-xs py-1.5`} />
            <input type="number" value={p.quantity ?? ''} onChange={e => update(i, 'quantity', Number(e.target.value) || 0)} placeholder="Qté" disabled={disabled} className={`${inputCls} text-xs py-1.5`} data-testid={`order-part-qty-${i}`} />
            {p.inventory_item_id
              ? <span className="text-[10px] text-violet-300 self-center" data-testid={`order-part-inv-${i}`}>Coût géré par l'inventaire</span>
              : <input type="number" step="0.01" value={p.unit_price ?? ''} onChange={e => update(i, 'unit_price', e.target.value)} placeholder="Coût unitaire $" disabled={disabled} className={`${inputCls} text-xs py-1.5`} data-testid={`order-part-cost-${i}`} />}
          </div>
        </div>
      ))}
    </div>
  );
};
